const JobCard = {

    // PAGE HEADER
    "job_card": "Job Card",

    // FIELDS
    "search": "Search",
    "premise": "Premise",
    "zone": "Zone",
    "level": "Level",
    "asset": "Asset Category",
    "asset_inward": "Asset",
    "date_from": "Date From",
    "date_to": "Date To",
    "status": "Status",

    "update_status_title": "Update Status",
    "update_status_text": "Select a new status for this job card",
    "description": "Description",
    "description_placeholder": "Enter description (optional)",
    "error_status_required": "Select Status",
    "status_updated": "Job Card Status Updated Successfully",

    "table_status": "STATUS",
    "table_date": "DATE",
    "table_asset": "ASSET",
    "table_job_card_number": "JOB CARD NO.",
    "table_timeline": "TIMELINE",
    "table_priority": "PRIORITY",
    "table_premise": "PREMISE",
    "table_zone": "ZONE",
    "table_level": "LEVEL",

}

export default JobCard;